'use client';

import dynamic from 'next/dynamic';

export const TradeModal = dynamic(() => import('./TradeModal').then((mod) => mod.TradeModal), {
  ssr: false,
});
